import * as React from 'react'

import { ProductPageData } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Query/Product/ProductPage'
import { VariantChoices } from '@thg-commerce/enterprise-network/src/transformers/product/options'

interface ReviewsContextProviderProps {
  product?: ProductPageData
  options: VariantChoices
  selectedVariant?: ProductPageData['variants'][0]
  setSelectedVariant?: React.Dispatch<
    React.SetStateAction<ProductPageData['variants'][0]>
  >
  preselectVariant?: boolean
}

type ReviewsContextInterface = ReviewsContextProviderProps

export const ReviewsPageContext = React.createContext<ReviewsContextInterface>({
  options: [],
})

export const ReviewsPageContextProvider: React.FunctionComponent<{
  product: ProductPageData
  options: VariantChoices
}> = (props) => {
  const [selectedVariant, setSelectedVariant] = React.useState(
    props.product.defaultVariant,
  )

  return (
    <ReviewsPageContext.Provider
      value={{
        selectedVariant,
        setSelectedVariant,
        product: props.product,
        options: props.options,
        preselectVariant: props.preselectVariant,
      }}
    >
      {props.children}
    </ReviewsPageContext.Provider>
  )
}
